import { models } from '../../_mocks_/models'
import { loadModelConfig } from './modelEngine/configuration'

import { ICompletedContextState } from '../type/modelType'
import { getUrlParams } from './utils'

export async function getModelConfiguration(context: ICompletedContextState) {
  // Assume this from Database

  const p = getUrlParams('p')
  const modelId = p ? p : models[0].id

  const model = await loadModelConfig(modelId, context)

  return {
    model: model,
  }
}
